import styled from '@emotion/styled';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { IconButton } from '@mui/material';
import { SettingsIcon } from 'components/shared/SettingsIcon/SettingsIcon';
import { motion } from 'framer-motion';
import { usePageManager } from 'hooks/pageManager/usePageManager';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  isMobileBurgerMenuOpenAtom,
  selectedCategoryDataAtom,
  selectedMobileBurgerTabDataAtom,
} from 'store/private/layout/layoutAtoms';
import { bootstrapInfos } from 'store/public/bootstrapInfo';

import { CloseTabs } from '../../svgIcons/CloseTabs';
import { MenuBar } from '../MenuBar/MenuBar';

export const MobileBurgerMenu = props => {
  const [getBootstrapInfos] = useAtom(bootstrapInfos);

  const [isMobileBurgerMenuOpen, setIsMobileBurgerMenuOpen] = useAtom(
    isMobileBurgerMenuOpenAtom,
  );
  const [selectedCategoryData, setSelectedCategoryData] = useAtom(
    selectedCategoryDataAtom,
  );
  const [selectedMobileBurgerTabData, setSelectedMobileBurgerTabData] = useAtom(
    selectedMobileBurgerTabDataAtom,
  );
  const { closeAllTabs, pages } = usePageManager();
  const navigate = useNavigate();

  const handleCloseTabs = () => {
    if (pages.length === 1 && pages[0].href === '/') return navigate('/');
    closeAllTabs();
    navigate('/');
  };

  const handleClickSearch = () => {
    const category =
      selectedMobileBurgerTabData.name === 'search'
        ? {
            ...selectedCategoryData,
          }
        : {
            id: selectedCategoryData.id,
            name: 'search',
            icon: <SearchRoundedIcon />,
            label: 'جستجو',
          };
    setSelectedMobileBurgerTabData(category);
    setSelectedCategoryData(category);
  };
  const hideSearch =
    ['search', 'windows'].includes(selectedCategoryData.name) ||
    ['search', 'windows'].includes(selectedMobileBurgerTabData.name);
  const displayWindows =
    selectedMobileBurgerTabData.name === 'windows' &&
    selectedCategoryData.name === 'windows';

  return (
    <Container
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <TitleBar>
        <span>
          {hideSearch ? null : (
            <IconButton onClick={() => handleClickSearch()}>
              <SearchRoundedIcon sx={{ color: 'white' }} />
            </IconButton>
          )}
          {displayWindows ? (
            <IconButton onClick={() => handleCloseTabs()}>
              <CloseTabs sx={{ color: 'white' }} />
            </IconButton>
          ) : null}
        </span>
        <IconButton onClick={() => setIsMobileBurgerMenuOpen(false)}>
          <CloseOutlinedIcon sx={{ color: 'white' }} />
        </IconButton>
      </TitleBar>
      <Content>
        <MenuBar mobileView />
      </Content>
      <AppLogoBox>
        <AppLogo
          // src={LogoSvg}
          src={`${getBootstrapInfos?.['server-download']}/Downloader/Process?Key=${getBootstrapInfos?.['logo-tempalate']}`}
          alt="logo"
        />
      </AppLogoBox>
    </Container>
  );
};

const Container = styled(motion.div)`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  background: linear-gradient(180deg, #010f19, #072b46, #083658, #06253d);
`;

const TitleBar = styled.div`
  width: 100%;
  height: 18px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  z-index: 10;
`;

const Content = styled.div`
  width: 100%;
  height: calc(100vh - 7rem);
  margin-top: -1rem;
`;

const AppLogoBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const AppLogo = styled.img`
  width: 74px;
`;
